export default "__VITE_ASSET__BMpYHfuT__"